export default __webpack_public_path__ + "static/media/4.8e06576e.png";